import { fetchBlob } from '../fetchers'

export async function requestAttachmentDownload(
  fullUrl: string,
  mimeType: string,
  fileName: string,
) {
  const requestUrl = `/Attachment?FullUrl=${encodeURI(
    fullUrl,
  )}&MimeType=${encodeURI(mimeType)}&FileName=${encodeURI(fileName)}`

  return await fetchBlob(requestUrl)
}
